module.exports = __webpack_public_path__ + "static/media/logo.8af32bb0.png";